//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { NameDisplayItem } from './NameDisplayItem';
import { StudentStatus } from './Enums';

export class StudentNameDisplayItem extends NameDisplayItem {
    Active: boolean = false;
    Status: StudentStatus = StudentStatus.Active;
    FamilyID: string | null = null;

    constructor(initializer?: Partial<StudentNameDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentNameDisplayItem";
}
